import { block as blockNS } from '../../cls';
import './tabs.less';

export var block = blockNS('tabs');

export var tabsList = block('tabsList');
export var tab = block('tab');
export var tabTarget = block('target')();